module.exports = __webpack_public_path__ + "static/img/dynamicc.412db42.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/dynamicc.png
// module id = gHAg
// module chunks = 45